import React, { useEffect } from 'react'
import bgImage from '../Images/about_one.png'
import Navbar from '../componenets/Navbar'
import Avatar_1 from '../Images/m3.jpeg'
import Avatar_2 from '../Images/m2.jpeg'
import Avatar_3 from '../Images/m1.jpeg'
import Npdc from '../Images/npdc1.png'
import Agip from '../Images/agip-logo.png'
import Hydro from '../Images/hydroserve1.png'
import Nlng from '../Images/nlng.png'
import Shell from '../Images/shell.png'
import Total from '../Images/total.png'
import Footer from '../componenets/Footer'
import Couresel_img from '../Images/c1.jpeg'
import Couresel_img2 from '../Images/c2.jpg'
import Couresel_img3 from '../Images/c3.jpeg'
import WOW from "wowjs";
import "animate.css";

const About = () => {

  useEffect(() => {
    new WOW.WOW({
      live: false
    }).init();
  }, []);
  
  return (
    <div>
      
    <Navbar />

    <section
      className="about_who-we-are"
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className="about_who-we-are-content">
        <p className="about_tag">Who We Are</p>
        <h1>Indigenous Expertise. Global Standards.</h1>
      </div>
    </section>

    <section className='about_our_history'>
        <div className="about_our_history_text wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
            <h2>Our History</h2>
            <p>WellClean Oil Field Services Limited is an indigenous engineering, logistics, procurement, fabrication and construction company. It was incorporated in 2020 in Nigeria and cerified with the Nigerian Petroleum Exchange (NiPEx).</p>
            <p>At WellClean Oil Field Services Limited, we provide quality services to companies in the upstream sector of the Nigerian Oil and Gas industry. Our extensive range of services include production drilling, conductor piling, casting/tubing running, mud logging, well overhauling/stimulation, webore clean up, filtration, well crises management services and other drilling services.</p>
        </div>
        <div className="about_our_history_img wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <div className="about_our_history_img_1">
                <img src={Couresel_img} alt="img" />
            </div>
            <div className="about_our_history_img_2">
                <img src={Couresel_img2} alt="img" />
                <img src={Couresel_img3} alt="img" />
            </div>
        </div>
    </section>

    <section className='about_our_mission_carrier'>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
            <h2>Our Mission</h2>
            <p>Our mission is to develop exceptional values to our clients in the areas of engineering, procurement and project management with regards to the environmental protection, health and safety. Utilizing technology and local resources to the maximum thereby enhancing the Nigerian content development.</p>
        </div>
        <div className="about_our_mission_img wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <img src={Avatar_3} alt="img" />
        </div>
    </section>

    <section className='about_our_vision'>
      <div className='about_our_vision_carrier'>
          <div className="about_our_mission_img wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
              <img src={Avatar_2} alt="img" />
          </div>
          <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
              <h2>Our Vision</h2>
              <p>Our vision is to become a world class company that meets the development needs of various sectors in the Nigerian economy and world at large.</p>
          </div>
      </div>
    </section>
    
    <section className='about_our_mission_carrier'>
        <div className="about_our_mission_text wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
            <h2>Our Approach</h2>
            <p>During drilling, completion and production, we minimize risks, reduce costs and we proactively identify and fix problems encountered.</p>
        </div>
        <div className="about_our_mission_img wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
            <img src={Avatar_1} alt="img" />
        </div>
    </section>

    <section>
      <div className="top_company">
        <div className="the_text_carrier wow animate__animated animate__fadeInUp" data-wow-delay="0.2s">
          <div className="orangeline"></div><span>Trusted By Top Companies in the Field</span><div className="orangeline"></div>
        </div>
        <div className="company_logo wow animate__animated animate__fadeInUp" data-wow-delay="0.3s">
          <div className="imgcarrier">
              <img src={Total} alt="Total" />
              <img src={Shell} alt="Shell" />
              <img src={Npdc} alt="Npdc" />
              <img src={Nlng} alt="NLNG" />
              <img src={Hydro} alt="Hydroserve" />
              <img src={Agip} alt="Agip" />
          </div>
        </div>
      </div>
    </section>

    <Footer />

    </div>
  )
}

export default About